import React from 'react'
import { Row, Col } from 'pui-react-grids'
import { Link } from 'react-router-dom'
import { themeColors } from '../styles/theme'
import FontIcon from 'material-ui/FontIcon'
import FlatButton from 'material-ui/FlatButton'
import { AFFIDABILITA_ICON_NAME } from '../styles/icons'
import { USER_ICON_NAME } from '../styles/icons'
import { PLACE_ICON_NAME } from '../styles/icons'
import { SWAPS_DONE_ICON_NAME } from '../styles/icons'

const styles = {
  name: {
    fontWeight: 'bold',
  },
  rowTitles: {
    color: themeColors.neutral,
    marginBottom: 20,
  },
  rowInfo: {
    borderBottom: '1px solid #ccc',
    paddingTop: 10,
    paddingBottom: 0,
  },
  mobileIcons: {
    color: 'inherit',
    position: 'relative',
    top: 3,
    fontSize: 18,
    marginRight: 3,
  },
  button: {
    position: 'relative',
    bottom: 6,
  },
  btnForSmall: {
    marginLeft: 'auto',
    marginBottom: 5,
  },
  userLinkStyle: {
    color: themeColors.positive,
    ':visited': {
      color: themeColors.positive,
    },
  },
}

const ItemOwnersTable = ({ item }) => (
  <div>
    <p>Questo oggetto è posseduto da:</p>
    <Row className="hidden-xs hidden-sm" style={styles.rowTitles}>
      <Col md={4} lg={4}>Nome</Col>
      <Col md={4} lg={4}>Provincia</Col>
      <Col md={4} lg={4}>Affidabilità</Col>
      <Col md={4} lg={4}>Transazioni concluse</Col>
      <Col md={4} lg={4}>Valore</Col>
      <Col md={2} lg={2}>Dettaglio</Col>
    </Row>
    {item.posseduto_da.map(owner => (
      <Row style={styles.rowInfo} key={owner.user.id}>
        <Col md={4} lg={4} sm={24} xs={24} style={styles.name}>
          <FontIcon
            className="material-icons hidden-md hidden-lg"
            style={styles.mobileIcons}>
            {USER_ICON_NAME}
          </FontIcon>
          <Link
            style={styles.userLinkStyle}
            to={`/user/${owner.user.username}`}>
            <strong>{owner.user.username}</strong>
          </Link>
        </Col>
        <Col md={4} lg={4} sm={24} xs={24}>
          <FontIcon
            className="material-icons hidden-md hidden-lg"
            style={styles.mobileIcons}>
            {PLACE_ICON_NAME}
          </FontIcon>
          {owner.user.district}
        </Col>
        <Col md={4} lg={4} sm={24} xs={24}>
          <FontIcon
            className="material-icons hidden-md hidden-lg"
            style={styles.mobileIcons}>
            {AFFIDABILITA_ICON_NAME}
          </FontIcon>
          {owner.user.transazioni > 3
            ? `${Number(owner.user.affidabilita * 100).toFixed()}%`
            : '-'}
        </Col>
        <Col md={4} lg={4} sm={24} xs={24}>
          <FontIcon
            className="material-icons hidden-md hidden-lg"
            style={styles.mobileIcons}>
            {SWAPS_DONE_ICON_NAME}
          </FontIcon>
          {owner.user.transazioni}
        </Col>
        <Col md={4} lg={4} sm={24} xs={24}>
          <FontIcon className="material-icons" style={styles.mobileIcons}>
            euro_symbol
          </FontIcon>
          {owner.valore}
        </Col>
        <Col md={4} lg={4} className="hidden-xs hidden-sm">
          <FlatButton
            label="Dettaglio"
            primary={true}
            containerElement={
              <Link to={`/item/${item.id}?userId=${owner.user.id}`} />
            }
            style={styles.button}
          />
        </Col>
        <Col
          sm={24}
          xs={24}
          className="hidden-md hidden-lg"
          style={{ display: 'flex' }}>
          <FlatButton
            label="Dettaglio"
            primary={true}
            containerElement={
              <Link to={`/item/${item.id}?userId=${owner.user.id}`} />
            }
            style={styles.btnForSmall}
          />
        </Col>
      </Row>
    ))}
  </div>
)

export default ItemOwnersTable



// WEBPACK FOOTER //
// ./src/common/ItemOwnersTable.js